// Formatação pt-BR usada no front e nos textos gerados pelo back.

export const MICROS = 1_000_000
export const toMicros = (reais: number) => Math.round(reais * MICROS)
export const fromMicros = (micros: number | null | undefined) => (micros ?? 0) / MICROS

export function brl(value: number, digits = 0): string {
  return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: digits, maximumFractionDigits: digits })
}

export function num(value: number, digits = 0): string {
  return value.toLocaleString('pt-BR', { minimumFractionDigits: digits, maximumFractionDigits: digits })
}

export function pct(ratio: number, digits = 0): string {
  const v = (ratio * 100).toFixed(digits).replace('.', ',')
  return `${ratio > 0 ? '+' : ''}${v}%`
}

export function plural(n: number, one: string, many: string): string {
  return `${num(n)} ${n === 1 ? one : many}`
}

export function dateBR(iso: string | Date): string {
  const d = typeof iso === 'string' ? new Date(iso) : iso
  return d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' })
}
